import React from 'react'
import QueryBuilderLib from 'react-querybuilder'
import { QueryBuilderBootstrap } from '@react-querybuilder/bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp, faCopy, faGripVertical, faLock, faTrash, faUnlock } from '@fortawesome/free-solid-svg-icons'
import { useReportBuilderContext } from '../ReportBuilderContext'

const icons = {
  trash: <FontAwesomeIcon icon={faTrash} />,
  copy: <FontAwesomeIcon icon={faCopy} />,
  gripVertical: <FontAwesomeIcon icon={faGripVertical} />,
  unlock: <FontAwesomeIcon icon={faUnlock} />,
  lock: <FontAwesomeIcon icon={faLock} />,
  up: <FontAwesomeIcon icon={faChevronUp} />,
  down: <FontAwesomeIcon icon={faChevronDown} />
}

const bootstrapTranslations = {
  removeGroup: { label: icons.trash },
  removeRule: { label: icons.trash },
  cloneRule: { label: icons.copy },
  cloneRuleGroup: { label: icons.copy },
  dragHandle: { label: icons.gripVertical },
  lockGroup: { label: icons.unlock },
  lockRule: { label: icons.unlock },
  lockGroupDisabled: { label: icons.lock },
  lockRuleDisabled: { label: icons.lock },
  shiftActionUp: { label: icons.up },
  shiftActionDown: { label: icons.down }
}

const QueryBuilder: React.FC = () => {
  const { fields, query, setQuery, model } = useReportBuilderContext()
  return (
    <QueryBuilderBootstrap key={model}>
      <QueryBuilderLib
        query={query}
        onQueryChange={setQuery}
        fields={fields}
        translations={bootstrapTranslations}
      />
    </QueryBuilderBootstrap>
  )
}

export default QueryBuilder
